import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
import { LanguageService } from "../cms/language.service";
import { AuthService } from "../core/auth.service";
import { ShoppingCartService } from "../inventory/shopping-cart.service";

import { UserLogin } from "./../../models/cms/user-login";
import { CurrencyService } from "./currency.service";


@Injectable()
export class CmsComponentService {
  constructor
    (
      public _api: ApiService,
      private mappings: Mappings,
      private language: LanguageService,
      private authService: AuthService,
      private cartService: ShoppingCartService,
      private currencyService: CurrencyService,
  ) { }

  getHeaderData() {
    //reading language
    let longLang: string = this.language.getLongLang();
    console.log(longLang)
    //reading userId
    let userId: string = this.authService.getCurrentUserId();

    let curr = this.currencyService.getCurrency();

    //reading template builder id
    let templateBuilderId: string = this.authService.getTemplBuilderId();
    //reading cartId
    let cartId: string = this.cartService.getCartId();
    cartId = encodeURIComponent(cartId);

    let url: string = this.mappings.Web_Api_Get_Header_Data
      .replace('{lang}', longLang)
      .replace('{userid}', userId)
      .replace('{cartid}', cartId)
      .replace('{currency}', curr)
      .replace('{templatebuilderid}', templateBuilderId);

    return this._api.get(url);
  }


  getSideMenuData() {
    //Reading language
    let longLang: string = this.language.getLongLang();
    //reading template builder id
    let templateBuilderId: string = this.authService.getTemplBuilderId();
    let url: string = this.mappings.Web_Api_Get_Side_Menu_Data
      .replace('{lang}', longLang)
      .replace('{templatebuilderid}', templateBuilderId);

    //Sending request to the server
    return this._api.get(url);
  }

  getHomePageDataOptimized() {
    //Reading language
    let longLang: string = this.language.getLongLang();

    //reading userId
    let userId: string = this.authService.getCurrentUserId();

    //reading cartId
    let cartId: string = this.cartService.getCartId();

    //reading template builder id
    let templateBuilderId: string = this.authService.getTemplBuilderId();

    //reading currency
    let curr = this.currencyService.getCurrency();

    cartId = encodeURIComponent(cartId);

    let url: string = this.mappings.Web_Api_Get_Home_Page_Data_Optimized
      .replace('{lang}', longLang)
      .replace('{userid}', userId)
      .replace('{cartid}', cartId)
      .replace('{currency}', curr)
      .replace('{templatebuilderid}', templateBuilderId);

    //Sending request to the server
    return this._api.get(url);
  }

  getproductHilightpromo() {
    //Reading language
    let longLang: string = this.language.getLongLang();

    let url: string = this.mappings.Web_Api_Get_Home_HilightPromoProduct
      .replace('{lang}', longLang);

    //Sending request to the server
    return this._api.get(url);
  }

  getSeoData() {
    //Reading language
    let longLang: string = this.language.getLongLang();
    let url: string = this.mappings.Web_Api_Get_Seo_Data.replace('{lang}', longLang);

    //Sending request to the server
    return this._api.get(url);
  }


  getSliderData(type: string, id: string) {
    //Reading language
    let longLang: string = this.language.getLongLang();

    let url: string = this.mappings.Web_Api_Get_Slider_Data
      .replace('{lang}', longLang)
      .replace('{id}', id)
      .replace('{type}', type);

    //Sending request to the server
    return this._api.get(url);
  }

  getFooterData() {
    //reading language
    let longLang: string = this.language.getLongLang();

    let curr = this.currencyService.getCurrency();

    let url: string = this.mappings.Web_Api_Get_Footer_Data
      .replace('{lang}', longLang)
      .replace('{currency}', curr);

    return this._api.get(url);
  }

  getShoppingCartData() {
    //reading language
    let longLang: string = this.language.getLongLang();

    //reading userId
    let userInfo: UserLogin = this.authService.GetData();
    let userId;
    if (userInfo != null) {
      userId = this.authService.GetUserId();
    }

    //reading cartId
    let cartId: string = this.cartService.getCartId();
    let curr = this.currencyService.getCurrency();

    let url: string = this.mappings.Web_Api_Get_Shopping_Cart_Data
      .replace('{lang}', longLang)
      .replace('{userid}', userId.toString())
      .replace('{cartid}', cartId)
      .replace('{currency}', curr);

    return this._api.getUniversalCached(url);
  }


  getShoppingCartCashData() {
    //reading language
    let longLang: string = this.language.getLongLang();

    //reading userId
    let userInfo: UserLogin = this.authService.GetData();
    let userId;

    if (userInfo != null) {
      userId = this.authService.GetUserId();
    }

    //reading cartId
    let cartId: string = this.cartService.getCartId();
    let curr = this.currencyService.getCurrency();

    let url: string = this.mappings.Web_Api_Get_Shopping_Cart_Cash_Data
      .replace('{lang}', longLang)
      .replace('{userid}', userId.toString())
      .replace('{cartid}', cartId.toString())
      .replace('{currency}', curr);

    return this._api.getUniversalCached(url);
  }

  getShoppingCartSubmittedData(orderId: string) {
    //reading language
    let longLang: string = this.language.getLongLang();

    //reading userId
    let userInfo: UserLogin = this.authService.GetData();
    let userId;

    if (userInfo != null) {
      userId = this.authService.GetUserId();
    }

    let curr = this.currencyService.getCurrency();
    let cartId = this.cartService.getCartId();
    let url: string = this.mappings.Web_Api_Get_Shopping_Cart_Submitted_Data
      .replace('{lang}', longLang)
      .replace('{userid}', userId.toString())
      .replace('{orderid}', orderId.toString())
      .replace('{currency}', curr)
      .replace("{cartid}", cartId);

    return this._api.getUniversalCached(url);
  }

  getOtherProductData(productId: string, userId: string) {
    //reading language
    let longLang: string = this.language.getLongLang();
    //reading template builder id
    let templateBuilderId: string = this.authService.getTemplBuilderId();
    let url: string = this.mappings.Web_Api_Get_Other_Product_Form_Data
      .replace('{lang}', longLang)
      .replace('{productid}', productId)
      .replace('{userId}', userId)
      .replace('{templatebuilderid}', templateBuilderId);

    return this._api.get(url);
  }

  getOfflinePageData() {
    //Reading language
    let longLang: string = this.language.getLongLang();
    let customerId = this.authService.GetUserId();
    let cartId = this.cartService.getCartId();

    let url: string = this.mappings.Web_Api_Get_Offline_Page_Data
      .replace('{lang}', longLang)
      .replace('{userid}', customerId)
      .replace('{cartid}', cartId);

    //Sending request to the server
    return this._api.get(url);
  }

  getLoginPageData() {
    //Reading language
    let longLang: string = this.language.getLongLang();
    let customerId = this.authService.GetUserId();
    let cartId = this.cartService.getCartId();
    let templateBuilderId: string = this.authService.getTemplBuilderId();

    let url: string = this.mappings.Web_Api_Get_Login_Page_Data
      .replace('{lang}', longLang)
      .replace('{userid}', customerId)
      .replace('{cartid}', cartId)
      .replace('{templatebuilderid}', templateBuilderId);


    //Sending request to the server
    return this._api.get(url);
  }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/cms-component.service.ts